import React from 'react';
import { Plus } from 'lucide-react';
import { Input } from '../../ui/input';
import { EMPTY_BUYER } from './constants';

function OfferBuyersStep({ form, setForm }) {
    const updateBuyer = (index, field, value) => {
        setForm((f) => {
            const buyers = [...f.buyers];
            buyers[index] = { ...buyers[index], [field]: value };
            return { ...f, buyers };
        });
    };

    const addBuyer = () => {
        setForm((f) => ({
            ...f,
            buyers: [...f.buyers, { ...EMPTY_BUYER }],
        }));
    };

    const removeBuyer = (index) => {
        if (form.buyers.length <= 1) return;
        setForm((f) => ({
            ...f,
            buyers: f.buyers.filter((_, i) => i !== index),
        }));
    };

    return (
        <div className="space-y-4">
            <p className="text-sm text-white/60">
                Informations de l'acquéreur. Ces données seront utilisées pour la signature électronique.
            </p>
            {form.buyers.map((buyer, idx) => (
                <div
                    key={`buyer-${idx}`}
                    className="space-y-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl"
                >
                    {form.buyers.length > 1 && (
                        <div className="flex items-center justify-between mb-1">
                            <p className="text-xs font-semibold text-white/50">Acquéreur {idx + 1}</p>
                            <button
                                onClick={() => removeBuyer(idx)}
                                className="text-xs text-red-400 hover:text-red-300"
                            >
                                Supprimer
                            </button>
                        </div>
                    )}
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Prénom *</label>
                            <Input
                                value={buyer.first_name}
                                onChange={(e) => updateBuyer(idx, 'first_name', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="Jean"
                                data-testid={`buyer-${idx}-first-name`}
                            />
                        </div>
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Nom *</label>
                            <Input
                                value={buyer.last_name}
                                onChange={(e) => updateBuyer(idx, 'last_name', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="Dupont"
                                data-testid={`buyer-${idx}-last-name`}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Email *</label>
                            <Input
                                type="email"
                                value={buyer.email}
                                onChange={(e) => updateBuyer(idx, 'email', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="jean@email.com"
                                data-testid={`buyer-${idx}-email`}
                            />
                        </div>
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Téléphone *</label>
                            <Input
                                value={buyer.phone}
                                onChange={(e) => updateBuyer(idx, 'phone', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="06 12 34 56 78"
                                data-testid={`buyer-${idx}-phone`}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="text-[10px] text-white/40 mb-1 block">Adresse</label>
                        <Input
                            value={buyer.address}
                            onChange={(e) => updateBuyer(idx, 'address', e.target.value)}
                            className="bg-white/5 border-white/10 text-white text-sm h-10"
                            placeholder="12 rue de la Paix"
                        />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Ville</label>
                            <Input
                                value={buyer.city}
                                onChange={(e) => updateBuyer(idx, 'city', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="Paris"
                            />
                        </div>
                        <div>
                            <label className="text-[10px] text-white/40 mb-1 block">Code postal</label>
                            <Input
                                value={buyer.postal_code}
                                onChange={(e) => updateBuyer(idx, 'postal_code', e.target.value)}
                                className="bg-white/5 border-white/10 text-white text-sm h-10"
                                placeholder="75001"
                            />
                        </div>
                    </div>
                </div>
            ))}
            <button
                onClick={addBuyer}
                className="w-full py-2.5 border border-dashed border-white/10 rounded-xl text-xs text-white/40 hover:text-white/60 hover:border-white/20 transition-colors flex items-center justify-center gap-2"
                data-testid="add-buyer-btn"
            >
                <Plus className="w-3.5 h-3.5" /> Ajouter un co-acquéreur
            </button>
        </div>
    );
}

export default OfferBuyersStep;
